import { TextAreaField } from 'shared-components/components/FormikComponents';

export const CONTACT_FIELDS = {
  FORM_HEADING: {
    NAME: 'formHeading',
    TITLE: 'Contact Details',
  },
  MOBILE: {
    NAME: 'primaryPhone',
    TITLE: 'Mobile*',
    PLACE_HOLDER: 'Enter at least one phone number',
    COMPONENT: TextAreaField,
  },
  HOME_PHONE: {
    NAME: 'secondaryPhone',
    TITLE: 'Home phone*',
    PLACE_HOLDER: 'Enter at least one phone number',
    COMPONENT: TextAreaField,
  },
  EMAIL: {
    NAME: 'email',
    TITLE: 'Email',
    PLACE_HOLDER: 'e.g. yourname@email.com',
    COMPONENT: TextAreaField,
  },
  EMPLOYER: {
    NAME: 'employer',
    TITLE: 'Employer',
    PLACE_HOLDER: 'Enter employer name',
    COMPONENT: TextAreaField,
  },
  WORK_PHONE: {
    NAME: 'workPhone',
    TITLE: 'Work phone',
    PLACE_HOLDER: 'Enter work phone number',
    COMPONENT: TextAreaField,
  },
};

export const EMAIL_VALIDATION = 'Please enter a valid email address.';
